<template>
    <!--Start Page Banner-->
    <div class="page-banner-area bg-1">
        <div class="container">
            <div class="page-banner-content">
                <h1>Principal's Message</h1>
                <ul>
                    <li><a href="/">Home</a></li>
                    <li>About</li>
                    <li>Principal's Message</li>
                </ul>
            </div>
        </div>
    </div>
    <!--End Page Banner-->

    <!-- MAIN start -->

    <section class="team-area-content">
        <div class="container"> <!-- Lower Content -->
            <div class="lower-content">
                <div class="row">
                    <div class="col-lg-5 col-md-12 col-sm-12">
                        <div class="team-img-box"> <img width="460" height="500" src="/vf/images/general/principal.png"
                                class="attachment-post-thumbnail size-post-thumbnail wp-post-image" alt=""
                                decoding="async" fetchpriority="high"></div>
                    </div>
                    <div class="text-column col-lg-7 col-md-12 col-sm-12">
                        <div class="s-about-content pl-30 wow fadeInRight" data-animation="fadeInRight" data-delay=".2s"
                            style="visibility: visible; animation-name: fadeInRight;">
                            <h2>Dr. Kirti Singh</h2>
                                <p><i>Principal, Vedanta P.G. Girls College Reengus</i></p>
                            <h3>Message</h3>
                            <div>
                                <div class="section">
                                    <h5>About Vedanta PG Girls College</h5>
                                    <p> Vedanta P.G College is a beacon of empowerment and enlightenment nestled in the
                                        heart of Reengus, Rajasthan. At Vedanta, we believe in the transformative power
                                        of education, particularly for women in rural communities who often face
                                        barriers to pursuing their dreams. </p>
                                    <p> As the Principal of Vedanta College PG Girls College of Rajasthan, it fills my
                                        heart with immense pride to lead an institution dedicated to empowering girls
                                        from every community. Drawing from my own journey in education, I am passionate
                                        about transforming lives by making our young women skilled, employable, and
                                        truly self-dependent—ready to chase their dreams with confidence. </p>
                                </div>
                                <div class="section">
                                    <h5>Academic Vision</h5>
                                    <p> We are proudly aligning with the National Education Policy (NEP 2020) through
                                        multidisciplinary learning, skill-based vocational courses in emerging fields
                                        and experiential education that blends academics with real-world projects. This
                                        ensures our girls gain holistic knowledge and practical expertise for tomorrow's
                                        job market. </p>
                                </div>
                                <div class="section">
                                    <h5>Community Outreach</h5>
                                    <p> Thanks to the visionary initiative of the Vedanta Foundation, we are extending
                                        our reach deeper into the community—offering scholarships for underprivileged
                                        girls, skill workshops for local women, and outreach programs that uplift
                                        families in Reengus and beyond. </p>
                                </div>

                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>

    <!-- Start Bottom Connect Area -->
    <div class="alumni-interview-area pb-100">
        <div class="container">
            <div class="interview-content ptb-100">
                <div class="interview">
                    <router-link href="/affiliation" class="default-btn btn">Affiliation<i
                            class="flaticon-next"></i></router-link>
                    <router-link to="/applynow" class="default-btn btn">Apply Now</router-link>
                </div>
            </div>
        </div>
    </div>
    <!--End Bottom Connect Area -->


    <!-- MAIN end -->
</template>

<script>
export default {
    name: "PrincipalMessageView"
};
</script>
